// extracted by mini-css-extract-plugin
export default {"genericSelect":"GenericStyles_genericSelect__Cu+DJ","GenericButton":"GenericStyles_GenericButton__7Ba+d"};